import React, { Component } from 'react';
export default class PoratlUnitJobHistory extends Component {
    constructor(props) {
        super(props);

        this.state = {
            text: props.initialValue || 'placeholder',
            unitHistory: '',
        };

        this.getUnitJobHistory();
    }

    getUnitJobHistory() {
        let url = '/api/v1/portal/portal-admin/units/' + this.props.data.id;
        return fetch(url, {
            method: "GET",
            mode: "cors",
            cache: "no-cache",
            credentials: "same-origin",
            headers: {
                "Authorization": 'Bearer ' + window.api_token
                , "Accept": 'application/json'
            },
        }).
            then((responseText) => {
                let response = responseText.json();
                response.then((unitHistory) => {
                    this.setState({
                        unitHistory: unitHistory,
                        isLoading: false
                    })
                });
            });
    }

    render() {
        const { id } = this.props.data
        let PortalUnitHistory = [];
        if (this.state.unitHistory && this.state.unitHistory.length > 0) {
            this.state.unitHistory.forEach(function (i) {
                if (i && i.id) {
                    PortalUnitHistory.push(
                        <div key={'portal-unit-id-' + i.id} className="portal-admin-table-row portal-admin-table-row-summary">
                            <div className="cell column-type-id">
                                {i.id}
                            </div>
                            <div className="cell column-type-pickup_cleaned_qty">
                                {i.pickup_cleaned_qty}
                            </div>
                            <div className="cell column-type-pickup_dirty_qty">
                                {i.pickup_dirty_qty}
                            </div>
                            <div className="cell column-type-dropoff_cleaned_qty">
                                {i.dropoff_cleaned_qty}
                            </div>
                            <div className="cell column-type-dropoff_dirty_qty">
                                {i.dropoff_dirty_qty}
                            </div>
                            <div className="cell column-type-driver">
                                 {i.driver?.user?.full_name}
                            </div>
                        </div>
                    );
                }
            });
        }
        else {
            PortalUnitHistory = "No history found for this Unit";
        }
        return (
            <div className="portal-admin-table-row portal-account-full-details"
                id={"portal-account-full-details-" + id}
                key={"portal-account-full-details-" + id}>
                <div className="row">
                    <div className="col-md-12">
                        <div className="portal-admin-table">

                            <div className="portal-admin-table-row header">
                                <div className="cell column-type-id">Job id</div>
                                <div className="cell column-type-pickup_cleaned_qty">pickup cleaned qty</div>
                                <div className="cell column-type-pickup_dirty_qty">pickup dirty qty</div>
                                <div className="cell column-type-dropoff_cleaned_qty">dropoff cleaned qty</div>
                                <div className="cell column-type-dropoff_dirty_qty">dropoff dirty qty</div>
                                <div className="cell column-type-driver">driver</div>
                            </div>
                            {
                                this.state.isLoading ?
                                    (<div className="loading-box">
                                        <span className="add-loading-text">
                                            <i className="fa fa-spinner fa-pulse"></i>
                                        </span>
                                    </div>) :
                                    PortalUnitHistory
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}